import {themr} from '@friendsofreactjs/react-css-themr';

import identifiers from '../identifiers';
import CheckBox from './checkBox';
import style from './style.css';

export default themr(identifiers.checkBox, style)(CheckBox);
